import { useFormContext } from '@calendly/form';
import { getTimezone } from '@calendly/timezone-tools';
import { TimezonePicker as CoreTimezonePicker } from '@calendly/timezone-tools/timezone-picker';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ControlUI } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { timeNotationSelector } from 'selectors/current_user';
const containerCss = "cvdd9vy";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const pickerCss = "p1o0sany";
const Picker = forwardRef((props, ref) => <CoreTimezonePicker ref={ref} {...props} className={classNames(pickerCss, props.className)} />);
export const TimezonePicker = () => {
  const [togglePicker, Dropdown, isOpen] = useDropdown();
  const timeNotation = useSelector(timeNotationSelector);
  const {
    values: {
      lockTimezoneStatus,
      lockTimezoneContent: timezone
    },
    setFieldValue,
    setFieldTouched
  } = useFormContext();
  const isDisabled = lockTimezoneStatus === 'local';
  const onSelectTimezone = id => {
    setFieldValue('lockTimezoneContent', id);
    setFieldTouched('lockTimezoneContent', true);
  };
  return <Container>
      <ControlUI onClick={togglePicker} expanded={isOpen} disabled={isDisabled}>
        {getTimezone(timezone).name}
      </ControlUI>
      <Dropdown>
        <Picker data-component="timezone-picker" selectedId={timezone} onChange={onSelectTimezone} timeNotation={timeNotation} aria-expanded={isOpen} />
      </Dropdown>
    </Container>;
};

require("./picker.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./picker.js");